module.exports = __webpack_public_path__ + "static/media/casino-min.4ff49aa5.jpg";